// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu--oWkt-","menu_change_in":"menu_change_in--1YyQA","menuChangeIn":"menuChangeIn--3-QXJ","menu_change_out":"menu_change_out--35mSb","menuChangeOut":"menuChangeOut--35DKZ"};